if(!customElements.get('product-description')) {
    class ProductDescription extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.selectors = {
                readMoreLess: this.querySelectorAll('.read-more-less button'),
                description: this.querySelector('.product-description')
            }

            if(this.selectors.readMoreLess.length > 0) {
                this.selectors.readMoreLess.forEach(btn => {
                    btn.addEventListener('click', event => {
                        if(event.target.closest('button').classList.contains('read-more')) {
                            event.target.closest('product-description').classList.add('read-more');
                            event.target.closest('product-description').classList.remove('read-less');
                        } else {
                            event.target.closest('product-description').classList.remove('read-more');
                            event.target.closest('product-description').classList.add('read-less');
                        }                       
                    })
                })
            }
        }
    }
    customElements.define('product-description', ProductDescription);
}